import React, { useRef, useState } from "react";
import { RCCAlert, RCCButton, RCCCheckBox, RCCGrid, RCCHierarchicalTree, RCCIcon, RCCTooltip, toggleExpandedForAll } from "react-common-components";
import LoadingContainer from "src/components/LoadingContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { SWOTType } from "src/pages/Analysis/SWOT/interface";
import swotLabels from "src/pages/Analysis/SWOT/SwotLabels";
import { SWOTHierarchyLevel } from "../interface";
import { IHierarchySWOT } from "./interface";
import { TextName } from "./styles";

const HierarchySWOT: React.FC<IHierarchySWOT> = ({
	SWOTId,
	SWOTItemId,
	register,
	initialData,
	setValue
}) => {
	const { translate } = useTranslation(); 

	const hierarchyDifRef = useRef<HTMLDivElement>(null);
	const [hierarchy, setHierarchy] = useState<any[]>([]);
	const [expandAll, setExpandAll] = useState(false);

	const showItens = () => {
		const newitens = toggleExpandedForAll({treeData:[...hierarchy],expanded:!expandAll});	
		setHierarchy(newitens);
		setExpandAll(!expandAll);
	};

	const {swotSections} = swotLabels(translate);	

	const { errorFetching, loading  } = useEffectFetchData<any[]> (
		"SWOT/SWOTHierarchy", { 	mes001Id: SWOTId, mes002Id: SWOTItemId },
		 ({ data }) => {
			setHierarchy(data);
			initialData?.forEach((id) => {
				setValue(`selectedSWOTItens-${id}`,id.toString());
			});
		 }
	);

	const setTypeName = (type: SWOTType) => swotSections.find((x) => x.type===type)?.title;

	return (
		<LoadingContainer loading={loading} hideContent={hierarchy && hierarchy.length === 0}>
			{errorFetching ? (
				<RCCAlert 
					color="red"
					title={translate("Atenção")}
					description={translate("Erro ao carregar dados")}
				/>
			) : (
				<>
					{
						hierarchy && hierarchy.length === 0 
							? (<RCCAlert 
								title={translate("Atenção")}
								description={translate("Nenhum resultado encontrado")}
							/>)
							: 
							(
								<>
									<RCCGrid container>
										<RCCGrid 
											container 
											justifyContent="flex-end"
										>
											<RCCTooltip
												text={expandAll ? translate("Recolher todos") : translate("Expandir todos")}
												position="left"
											>
												<RCCButton 
													onClick = {() => {showItens();}}
													icon = {{
														name: expandAll ? "compress" : "expand"
													}}
													layout="isRounded"
													size="md"
												/>
											</RCCTooltip>
										</RCCGrid>
										<div 
											ref={hierarchyDifRef}
											style={{ width: "100%" }}
										>
											<RCCHierarchicalTree
												data={hierarchy}
												onChange={(treeData) => setHierarchy(treeData)}
												customNode={({
													node
												}) => (
													<RCCGrid 
														container
														item
														alignItems="center"
														styleInline={`color:${node.color}`}
													>
														{
															node.level === SWOTHierarchyLevel.ITEM ? (
																<RCCCheckBox 
																	styleInline={{checkbox: "margin-right: 5px;"}}
																	name={`selectedSWOTItens-${node.id}`} 
																	register={register} 
																	value={node.id}
																/>
															) : null
														}
														<RCCGrid 
															container
															item
															alignItems="center"
															xs={11}
														>
															{
																node.level !== SWOTHierarchyLevel.ITEM &&
																<RCCIcon 
																	name={node.level===SWOTHierarchyLevel.DIMENSION ? "cube":"squares"} 
																	style={{ marginRight: "5px", marginLeft: "5px", color: "var(--input-font-color)" }} 
																/>
															}
															<TextName>{node.level === SWOTHierarchyLevel.SECTION ? setTypeName(node.type) : node.name}</TextName>
														</RCCGrid>
													</RCCGrid>
												)}
												canDrop={() => false}
												canDrag={() => false}
												rowHeight={50}
											/>
										</div>
									</RCCGrid>
								</>
							)
					}
				</>
			)}
		</LoadingContainer>
	);
};

export default HierarchySWOT;
